export function getPartitionsFor(amount: number): string[] {
  if (!amount) {
    return [];
  }

  return Array.from({ length: amount }, (_, idx) => `${idx + 1}/${amount}`);
}
